/* Built In Imports*/
import { useEffect } from 'react';
/* External Imports */
import { Box, Link, Image } from '@chakra-ui/react';

/* Internal Imports */
/* Components  */
import config from '@config';

/* Services */
/**
 * Renders the US ChatBot Component
 *
 * @param
 * @returns {ReactElement} - US Donation Component
 */
export default function DoubleTheDonation() {
  useEffect(() => {
    window.DDCONF = {
      API_KEY: "ZGNkYjRjMDAtNDM0",
    };

    const script = document.createElement("script");
    script.src = "https://doublethedonation.com/api/js/ddplugin.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Box id="dd-container">
      <Link href="https://doublethedonation.com/matching-grant-resources/matching-gift-basics">Matching Gift</Link> and
      <Link href="https://doublethedonation.com/matching-grant-resources/volunteer-grant-basics">Volunteer Grant</Link> information provided by <br />
      <Link href="https://doublethedonation.com">
        <Image
          alt="Powered by Double the Donation"
          src="https://doublethedonation.com/api/img/powered-by.png"
        />
      </Link>
    </Box>
  );
};
